'use strict';

angular.module('amexReconciliationApp')
  .component('sessionCountdown', {
    template: '' +
      '<div id="session-countdown" class="text-right dark-font small-font" ng-show="$ctrl.displayCountdown()">' +
      '<span translate>directives.sessionCountdown.SessionTimeout</span>: {{ $ctrl.timeRemaining() | millisecondsToMinutes }}' +
      '</div>',
    controller: function (SessionTimeoutService) {
      var self = this;

      self.displayCountdown = function () {
        return SessionTimeoutService.getRemainingTime() <= SessionTimeoutService.warningCountdownLength;
      };

      self.timeRemaining = function () {
        return SessionTimeoutService.getRemainingTime();
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/sessionCountdown.js
// module id = 534
// module chunks = 0